<template>
  <div class="page_injuryTables">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div>
          <!-- <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
            <el-form-item label="险种名称" size="small">
              <el-input v-model="listQuery.InsuranceName" size="small" clearable></el-input>
            </el-form-item>
          </el-form> -->
        </div>
      </div>
      <div class="top-right">
        <!-- <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button> -->
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>工伤一览表</el-breadcrumb-item>
          <el-breadcrumb-item>赔付明细1-社保</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="addNew">&nbsp;新增+</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column prop="Sort" label="序号" width="60" align="center" fixed="left">
            <template slot-scope="scope">
              {{(listQuery.pageNum - 1) * Number(listQuery.pageSize)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="r.Idcard" label="身份证号码" width="155" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="r.TimeInjury" label="发生工伤日期" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="rw.InjuredEmployeeName" label="工伤员工姓名" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="rw.ProjectName" label="项目名称" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="rw.BranchOffice" label="分公司" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.SocialSecurityInjuryManager" label="社保工伤负责人" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InvoiceValue" label="发票金额" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.SickLeaveTime" label="病假时间" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.DegreeDisability" label="伤残等级" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.FirstReportingParty" label="第一申报方（社保全称）" width="170" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.WorkInjurymedicalExpense" label="工伤医疗费" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.WindowReimbursementTime" label="窗口报销时间" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AccountingTimeSs" label="到账时间（社保局打给员工）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AccountingTimeSstoEnt" label="到账时间（社保局打给企业）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.OneTimeDisabilityBenefit" label="一次性伤残补助金" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.WindowReimbursementTime1" label="窗口报销时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AccountingTimeSs1" label="到账时间（社保局打给员工）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AccountingTimeSstoEnt1" label="到账时间（社保局打给企业）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Other" label="其他" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.WindowReimbursementTime2" label="窗口报销时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AccountingTimeSs2" label="到账时间（社保局打给员工）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AccountingTimeSstoEnt2" label="到账时间（社保局打给企业）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InjurAppraisalFee" label="工伤鉴定费" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.WindowReimbursementTime3" label="窗口报销时间" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AccountingTimeSs3" label="到账时间（社保局打给员工）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AccountingTimeSstoEnt3" label="到账时间（社保局打给企业）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.OnetimeEorkRelatedInjuryMedical" label="一次性工伤医疗补助金" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.WindowReimbursementTime4" label="窗口报销时间" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AccountingTimeSs4" label="到账时间（社保局打给员工）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AccountingTimeSstoEnt4" label="到账时间（社保局打给企业）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.ResignationTime" label="离职时间（社保终止时间）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column prop="r.OnetimeEorkRelatedInjuryMedical1" label="一次性伤残就业补助金" :show-overflow-tooltip="true" align="center" width="120">
          </el-table-column>
          <el-table-column prop="r.WindowReimbursementTime5" label="窗口报销时间" :show-overflow-tooltip="true" align="center" width="120">
          </el-table-column>
          <el-table-column prop="r.AccountingTimeSs5" label="到账时间（社保局打给员工）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AccountingTimeSstoEnt5" label="到账时间（社保局打给企业）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
          <el-table-column prop="r.Total" label="合计" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Remark1" label="社保赔付备注1" width="120" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column prop="r.Remark2" label="社保赔付备注2" width="120" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="90px">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="edit(row)">编辑</el-button>
                <el-popconfirm title="请确定是否作废？" @confirm="del(row)" style="margin-left: 10px;">
                  <el-button type="text" slot="reference">作废</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="新增" :visible.sync="showAdd" width="1050px">
      <div class="formData">
        <el-form :model="formData" :inline="true" ref="formData" :rules="rules" label-width="170px">
          <el-form-item label="身份证号码" prop="Idcard">
            <el-input v-model.trim="formData.Idcard" style="width:300px" size="small" @blur="getIdcardInfo"></el-input>
          </el-form-item>
          <el-form-item label="发生工伤日期" prop="TimeInjury">
            <!-- <el-date-picker type="date" placeholder="" v-model="formData.TimeInjury" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker> -->
            <el-select v-model="formData.TimeInjury" placeholder="" clearable size="small" style="width:300px" value-key="Id" @change="changeTimeInjury">
              <el-option v-for="(item,index) in injuryDateList" :key="index" :label="item.TimeInjury" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工伤员工姓名">
            <el-input v-model="name" disabled readonly style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="项目名称">
            <el-input v-model="proName" disabled readonly style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="SocialSecurityInjuryManager">
            <template #label>
              <span>社保工伤负责人
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>维护此表的负责人。</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.SocialSecurityInjuryManager" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="发票金额" prop="InvoiceValue">
            <el-input v-model="formData.InvoiceValue" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="病假时间" prop="SickLeaveTime">
            <el-input v-model="formData.SickLeaveTime" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="伤残等级" prop="DegreeDisability">
            <el-input v-model="formData.DegreeDisability" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="第一申报方（社保全称）" prop="FirstReportingParty">
            <el-input v-model="formData.FirstReportingParty" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="工伤医疗费" prop="WorkInjurymedicalExpense">
            <el-input v-model="formData.WorkInjurymedicalExpense" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="窗口报销时间" prop="WindowReimbursementTime">
            <el-date-picker type="date" placeholder="" v-model="formData.WindowReimbursementTime" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="到账时间（社保局打给员工）">
            <el-date-picker type="date" placeholder="" v-model="formData.AccountingTimeSs" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="到账时间（社保局打给企业）" prop="AccountingTimeSstoEnt">
            <el-date-picker type="date" placeholder="" v-model="formData.AccountingTimeSstoEnt" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="一次性伤残补助金" prop="OneTimeDisabilityBenefit">
            <el-input v-model="formData.OneTimeDisabilityBenefit" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="窗口报销时间" prop="WindowReimbursementTime1">
            <el-date-picker type="date" placeholder="" v-model="formData.WindowReimbursementTime1" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="到账时间（社保局打给员工）">
            <el-date-picker type="date" placeholder="" v-model="formData.AccountingTimeSs1" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="到账时间（社保局打给企业）" prop="AccountingTimeSstoEnt1">
            <el-date-picker type="date" placeholder="" v-model="formData.AccountingTimeSstoEnt1" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="其他" prop="Other">
            <el-input v-model="formData.Other" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="窗口报销时间" prop="WindowReimbursementTime2">
            <el-date-picker type="date" placeholder="" v-model="formData.WindowReimbursementTime2" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="到账时间（社保局打给员工）">
            <el-date-picker type="date" placeholder="" v-model="formData.AccountingTimeSs2" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="到账时间（社保局打给企业）" prop="AccountingTimeSstoEnt2">
            <el-date-picker type="date" placeholder="" v-model="formData.AccountingTimeSstoEnt2" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="工伤鉴定费" prop="InjurAppraisalFee">
            <el-input v-model="formData.InjurAppraisalFee" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="窗口报销时间" prop="WindowReimbursementTime3">
            <el-date-picker type="date" placeholder="" v-model="formData.WindowReimbursementTime3" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="到账时间（社保局打给员工）">
            <el-date-picker type="date" placeholder="" v-model="formData.AccountingTimeSs3" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="到账时间（社保局打给企业）" prop="AccountingTimeSstoEnt3">
            <el-date-picker type="date" placeholder="" v-model="formData.AccountingTimeSstoEnt3" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="一次性工伤医疗补助金" prop="OnetimeEorkRelatedInjuryMedical">
            <el-input v-model="formData.OnetimeEorkRelatedInjuryMedical" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="窗口报销时间" prop="WindowReimbursementTime4">
            <el-date-picker type="date" placeholder="" v-model="formData.WindowReimbursementTime4" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="到账时间（社保局打给员工）">
            <el-date-picker type="date" placeholder="" v-model="formData.AccountingTimeSs4" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="到账时间（社保局打给企业）" prop="AccountingTimeSstoEnt4">
            <el-date-picker type="date" placeholder="" v-model="formData.AccountingTimeSstoEnt4" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="离职时间（社保终止时间）" prop="ResignationTime">
            <el-date-picker type="date" placeholder="" v-model="formData.ResignationTime" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="一次性伤残就业补助金" prop="OnetimeEorkRelatedInjuryMedical1">
            <el-input v-model="formData.OnetimeEorkRelatedInjuryMedical1" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="窗口报销时间" prop="WindowReimbursementTime5">
            <el-date-picker type="date" placeholder="" v-model="formData.WindowReimbursementTime5" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="到账时间（社保局打给员工）" prop="AccountingTimeSs5">
            <el-date-picker type="date" placeholder="" v-model="formData.AccountingTimeSs5" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="到账时间（社保局打给企业）" prop="AccountingTimeSstoEnt5">
            <el-date-picker type="date" placeholder="" v-model="formData.AccountingTimeSstoEnt5" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item> -->
          <el-form-item label="合计" prop="Total">
            <el-input v-model="formData.Total" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="社保赔付备注1" prop="Remark1">
            <el-input v-model="formData.Remark1" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="社保赔付备注2" prop="Remark2">
            <el-input v-model="formData.Remark2" style="width:300px" size="small"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAdd = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmSubmit">提 交</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import FUN from "../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    nextTick
  } from 'vue';
  export default {
    data() {
      return {
        listQuery: {
          InsuranceName: '', //险种名称
          ServerName: '', //服务商
          Bntype: '', //商保类别
          pageNum: 1,
          pageSize: 10,
        },
        tableData: [{
          name: '666'
        }],
        totalCount: 0,
        loading: false,
        showAdd: false,
        roletype:localStorage.loginRoletype,
        formData: {
          Id: '',
          Idcard: '', //身份证号码
          TimeInjury: '', //发生工伤时间（年-月-日）
          SocialSecurityInjuryManager: '', //社保工伤负责人
          InvoiceValue: '', //发票金额
          SickLeaveTime: '', //病假时间
          DegreeDisability: '', //伤残等级
          FirstReportingParty: '', //第一申报方（社保全称）
          WorkInjurymedicalExpense: '', //工伤医疗费
          WindowReimbursementTime: '', //窗口报销时间
          AccountingTimeSs: '', //到账时间 社保局打给员工）
          AccountingTimeSstoEnt: '', //到账时间（社保局打给企业）
          OneTimeDisabilityBenefit: '', //一次性伤残补助金
          WindowReimbursementTime1: '', //窗口报销时间1
          AccountingTimeSs1: '', //到账时间（社保局打给员工）1
          AccountingTimeSstoEnt1: '', //到账时间（社保局打给企业）1
          Other: '', //其他
          WindowReimbursementTime2: '', //窗口报销时间2
          AccountingTimeSs2: '', //到账时间（社保局打给员工）2
          AccountingTimeSstoEnt2: '', //到账时间（社保局打给企业）2
          InjurAppraisalFee: '', //工伤鉴定费
          WindowReimbursementTime3: '', //窗口报销时间3
          AccountingTimeSs3: '', //到账时间（社保局打给员工）3
          AccountingTimeSstoEnt3: '', //到账时间（社保局打给企业）3
          OnetimeEorkRelatedInjuryMedical: '', //一次性工伤医疗补助金1
          WindowReimbursementTime4: '', //窗口报销时间4
          AccountingTimeSs4: '', //到账时间（社保局打给员工）4
          AccountingTimeSstoEnt4: '', //到账时间 社保局打给企业）4
          ResignationTime: '', //离职时间（社保终止时间）
          OnetimeEorkRelatedInjuryMedical1: '', //一次性工伤医疗补助金2
          WindowReimbursementTime5: '', //窗口报销时间5
          AccountingTimeSs5: '', //到账时间（社保局打给员工）5
          AccountingTimeSstoEnt5: '', //到账时间（社保局打给企业）5
          Total: '', //合计
          Remark1: '', //备注1
          Remark2: '', //备注2
        },
        rules: {
          Idcard: {
            required: true,
            message: '请输入身份证号码',
            trigger: 'blur'
          },
          TimeInjury: {
            required: true,
            message: '请输入发生工伤日期',
            trigger: 'blur'
          },
          SocialSecurityInjuryManager: {
            required: true,
            message: '请输入社保工伤负责人',
            trigger: 'blur'
          },
          InvoiceValue: {
            required: true,
            message: '请输入发票金额',
            trigger: 'blur'
          },
          SickLeaveTime: {
            required: true,
            message: '请输入病假时间',
            trigger: 'blur'
          },
          DegreeDisability: {
            required: true,
            message: '请输入伤残等级',
            trigger: 'blur'
          },
          FirstReportingParty: {
            required: true,
            message: '请输入第一申报方（社保全称）',
            trigger: 'blur'
          },
          WorkInjurymedicalExpense: {
            required: true,
            message: '请输入工伤医疗费',
            trigger: 'blur'
          },
          WindowReimbursementTime: {
            required: true,
            message: '请输入窗口报销时间',
            trigger: 'blur'
          },
          AccountingTimeSs: {
            required: true,
            message: '请输入到账时间（社保局打给员工）',
            trigger: 'blur'
          },
          AccountingTimeSstoEnt: {
            required: true,
            message: '请输入到账时间（社保局打给企业）',
            trigger: 'blur'
          },
          OneTimeDisabilityBenefit: {
            required: true,
            message: '请输入一次性伤残补助金',
            trigger: 'blur'
          },
          WindowReimbursementTime1: {
            required: true,
            message: '请输入窗口报销时间',
            trigger: 'blur'
          },
          AccountingTimeSs1: {
            required: true,
            message: '请输入到账时间（社保局打给员工）',
            trigger: 'blur'
          },
          AccountingTimeSstoEnt1: {
            required: true,
            message: '请输入到账时间（社保局打给企业）',
            trigger: 'blur'
          },
          Other: {
            required: true,
            message: '请输入其他',
            trigger: 'blur'
          },
          WindowReimbursementTime2: {
            required: true,
            message: '请输入窗口报销时间',
            trigger: 'blur'
          },
          AccountingTimeSs2: {
            required: true,
            message: '请输入到账时间（社保局打给员工）',
            trigger: 'blur'
          },
          AccountingTimeSstoEnt2: {
            required: true,
            message: '请输入到账时间（社保局打给企业）',
            trigger: 'blur'
          },
          InjurAppraisalFee: {
            required: true,
            message: '请输入工伤鉴定费',
            trigger: 'blur'
          },
          WindowReimbursementTime3: {
            required: true,
            message: '请输入窗口报销时间',
            trigger: 'blur'
          },
          AccountingTimeSs3: {
            required: true,
            message: '请输入到账时间（社保局打给员工）',
            trigger: 'blur'
          },
          AccountingTimeSstoEnt3: {
            required: true,
            message: '请输入到账时间（社保局打给企业）',
            trigger: 'blur'
          },
          OnetimeEorkRelatedInjuryMedical: {
            required: true,
            message: '请输入一次性工伤医疗补助金',
            trigger: 'blur'
          },
          WindowReimbursementTime4: {
            required: true,
            message: '请输入窗口报销时间',
            trigger: 'blur'
          },
          AccountingTimeSs4: {
            required: true,
            message: '请输入到账时间（社保局打给员工）',
            trigger: 'blur'
          },
          AccountingTimeSstoEnt4: {
            required: true,
            message: '请输入到账时间（社保局打给企业）',
            trigger: 'blur'
          },
          ResignationTime: {
            required: true,
            message: '请输入离职时间（社保终止时间）',
            trigger: 'blur'
          },
          OnetimeEorkRelatedInjuryMedical1: {
            required: true,
            message: '请输入一次性伤残就业补助金',
            trigger: 'blur'
          },
          WindowReimbursementTime5: {
            required: true,
            message: '请输入窗口报销时间',
            trigger: 'blur'
          },
          AccountingTimeSs5: {
            required: true,
            message: '请输入到账时间（社保局打给员工）',
            trigger: 'blur'
          },
          AccountingTimeSstoEnt5: {
            required: true,
            message: '请输入到账时间（社保局打给企业）',
            trigger: 'blur'
          },
          Total: {
            required: true,
            message: '请输入合计',
            trigger: 'blur'
          },
          Remark1: {
            required: true,
            message: '请输入社保赔付备注1',
            trigger: 'blur'
          },
          Remark2: {
            required: true,
            message: '请输入社保赔付备注2',
            trigger: 'blur'
          },
        },
        injuryDateList: [], //工伤日期列表
        name: '',
        proName: '',
      }
    },
    created() {
      this.getWiclaimDetails1Ss6List();
    },
    methods: {
      checkPermission,
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getWiclaimDetails1Ss6List();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getWiclaimDetails1Ss6List();
      },
      searchHandle() {
        this.listQuery.pageNum = 1;
        this.getWiclaimDetails1Ss6List();
      },
      //取【6】赔付明细1-社保列表
      getWiclaimDetails1Ss6List() {
        this.loading = true;
        xz.getWiclaimDetails1Ss6List(this.listQuery, this.roletype).then(res => {
          if (res.status == "ok") {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalcount;
            this.loading = false;
          } else {
            this.loading = false;
            this.tableData = [];
          }
        })
      },
      //新增
      addNew() {
        this.clearForm();
        this.showAdd = true;
      },
      edit(item) {
        //取【6】赔付明细1-社保详情
        xz.getWiclaimDetails1Ss6(item.r.Id, this.roletype).then(res => {
          if (res.status == "ok") {
            this.formData = res.data;
          } else {
            this.formData = item;
          }
          this.showAdd = true;
        })
      },
      //确认新增/修改
      confirmSubmit() {
        this.$refs["formData"].validate((valid) => {
          if (valid) {
            xz.updataWiclaimDetails1Ss6(this.formData, this.roletype).then(res => {
              if (res.status == "ok") {
                this.showAdd = false;
                this.getWiclaimDetails1Ss6List();
                this.$message.success('新增成功！')
              } else {
                this.showAdd = false;
                this.$message.error(res.msg)
              }
            })
          }
        })
      },
      //删除【6】赔付明细1-社保详情
      del(item) {
        xz.delWiclaimDetails1Ss6(item.r.Id, this.roletype).then(res => {
          if (res.status == "ok") {
            this.getWiclaimDetails1Ss6List();
            this.$message.success('作废成功！')
          } else {
            this.getWiclaimDetails1Ss6List();
            this.$message.error(res.msg)
          }
        })
      },
      clearForm() {
        this.name = '';
        this.proName = '';
        this.formData = {
          Id: '',
          Idcard: '', //身份证号码
          TimeInjury: '', //发生工伤时间（年-月-日）
          SocialSecurityInjuryManager: '', //社保工伤负责人
          InvoiceValue: '', //发票金额
          SickLeaveTime: '', //病假时间
          DegreeDisability: '', //伤残等级
          FirstReportingParty: '', //第一申报方（社保全称）
          WorkInjurymedicalExpense: '', //工伤医疗费
          WindowReimbursementTime: '', //窗口报销时间
          AccountingTimeSs: '', //到账时间 社保局打给员工）
          AccountingTimeSstoEnt: '', //到账时间（社保局打给企业）
          OneTimeDisabilityBenefit: '', //一次性伤残补助金
          WindowReimbursementTime1: '', //窗口报销时间1
          AccountingTimeSs1: '', //到账时间（社保局打给员工）1
          AccountingTimeSstoEnt1: '', //到账时间（社保局打给企业）1
          Other: '', //其他
          WindowReimbursementTime2: '', //窗口报销时间2
          AccountingTimeSs2: '', //到账时间（社保局打给员工）2
          AccountingTimeSstoEnt2: '', //到账时间（社保局打给企业）2
          InjurAppraisalFee: '', //工伤鉴定费
          WindowReimbursementTime3: '', //窗口报销时间3
          AccountingTimeSs3: '', //到账时间（社保局打给员工）3
          AccountingTimeSstoEnt3: '', //到账时间（社保局打给企业）3
          OnetimeEorkRelatedInjuryMedical: '', //一次性工伤医疗补助金1
          WindowReimbursementTime4: '', //窗口报销时间4
          AccountingTimeSs4: '', //到账时间（社保局打给员工）4
          AccountingTimeSstoEnt4: '', //到账时间 社保局打给企业）4
          ResignationTime: '', //离职时间（社保终止时间）
          OnetimeEorkRelatedInjuryMedical1: '', //一次性工伤医疗补助金2
          WindowReimbursementTime5: '', //窗口报销时间5
          AccountingTimeSs5: '', //到账时间（社保局打给员工）5
          AccountingTimeSstoEnt5: '', //到账时间（社保局打给企业）5
          Total: '', //合计
          Remark1: '', //备注1
          Remark2: '', //备注2
        }
      },
      getIdcardInfo() {
        if (this.formData.Idcard.length == 18) {
          let data = {
            pageNum: 1,
            pageSize: 1000,
            Idcard: this.formData.Idcard
          }
          xz.getWIAccidentReportList(data, this.roletype).then(res => {
            if (res.status == "ok") {
              if (res.data.data.length > 0) {
                this.injuryDateList = res.data.data;
              } else {
                this.injuryDateList = [];
                this.$message.error('请先添加工伤事故报告信息')
              }
            } else {
              this.injuryDateList = [];
              this.$message.error('获取身份证信息失败')
            }
          })
        }
      },
      changeTimeInjury(val) {
        this.formData.TimeInjury = val.TimeInjury;
        this.name = val.InjuredEmployeeName;
        this.proName = val.ProjectName;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }
</style>
<style>
  .page_injuryTables .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_injuryTables .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_injuryTables .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_injuryTables .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_injuryTables .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_injuryTables .formData .el-form-item {
    margin-bottom: 10px;
  }

  .page_injuryTables .formData .el-form-item__error {
    top: 34px;
  }

  .page_injuryTables .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_injuryTables .formData .el-icon-question:before {
    color: #F56C6C;
  }
</style>